'use client'
import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react'; // Using Lucide Heart icon

export type Product = {
  id: number;
  title: string;
  price: number;
  rating: number;
  reviews: number;
  image: string;
  category: string;
  isFavorite?: boolean;
  isBestBuy?: boolean;
};

interface PropsType {
  product: Product;
}

const ProductCard: React.FC<PropsType> = ({ product }) => {
  return (
    <Link to='/computers/zeus-max'>
      <div className="w-full p-2">
        <div className="bg-white rounded-xl p-4 relative flex flex-col items-center text-center shadow-sm">
          {/* Heart Icon */}
          <button className="absolute top-3 right-3 text-xl text-gray-400 focus:outline-none" aria-label={product.isFavorite ? 'Remove from favorites' : 'Add to favorites'}>
            {product.isFavorite ? <Heart fill="#dc2626" className="h-5 w-5 text-red-500" /> : <Heart className="h-5 w-5 text-gray-400" />}
          </button>

          {/* Spacer under heart */}
          <div className="h-6" />

          {/* Product Image */}
          <div className="w-full max-w-[140px] h-auto mb-4 mt-5">
            <img
              src={product.image}
              alt={product.title}
              className="w-full h-full max-h-[100px] object-contain"
            />
          </div>

          {/* Title and Subtitle */}
          <div className="mb-3 flex flex-col items-start w-full px-1 text-left">
            <h3 className="text-gray-800 text-sm font-semibold leading-tight">
              {product.title}
            </h3>
            <p className="text-gray-400 text-xs">Monitor</p>
          </div>

          {/* Availability + Button Row */}
          <div className="w-full flex justify-between items-center px-1">
            <span className="text-green-500 text-[10px] font-medium">Dostupno</span>
            <button className="bg-yellow-500 hover:bg-yellow-600 text-white text-[10px] font-semibold py-1 md:py-[6px] px-3 rounded-full focus:outline-none">
              Saznaj više
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;